import { TeacherPortalDashboard } from '@features/dashboards/teacher-portal/TeacherPortalDashboard'
import { requireRouteAudience } from '@services/router/routeAccess'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/teacher-portal')({
    component: () => 
        <TeacherPortalDashboard />,
    beforeLoad: requireRouteAudience(['staff']),
})
